import React, { useState } from "react";
import { getDomain } from "../../constants";
import EnvironmentSelector from "../options/environment_selector";
import InvisibleRequest from "../options/invisible_request";
import EmbedContainer from "../embed/container";
const MngBikeDemo = () => {
  const [token, setToken] = useState("fkPEa6wh2X9qXfhEB8e6qAdgWKLurUU9");
  const [locale, setLocale] = useState("fr");
  const [environment, setEnvironment] = useState("development");
  const [invisible, setInvisible] = useState(true);
  const domain = getDomain(environment);
  return (
    <div>
      <h1>MNG Bike Demo</h1>
      <EnvironmentSelector onChange={(env) => setEnvironment(env)} />
      <InvisibleRequest onChange={(invisible) => setInvisible(invisible)} />
      <div>
        <label style={{ marginRight: "10px" }}>Locale:</label>
        <select value={locale} onChange={(e) => setLocale(e.target.value)}>
          <option value="fr">FR</option>
          <option value="nl">NL</option>
        </select>
      </div>
      <div>
        <label style={{ marginRight: "10px" }}>Embed Token:</label>
        <input
          type="text"
          value={token}
          onChange={(e) => setToken(e.target.value)}
        />
      </div>
      {token && (
        <div key={`${token}-${locale}`}>
          <EmbedContainer
            embedUrl={`${domain}?aet=${token}&brand=mng-insurance&theme=mng-insurance&locale=${locale}&invisible=${invisible}`}
            showCode={true}
            urlToShow={`${domain}?aet=${token}&brand=mng-insurance&theme=mng-insurance&locale=${locale}`}
          />
        </div>
      )}
    </div>
  );
};

export default MngBikeDemo;
